export class CallbackErrorsContext {
  trigger_text: string;
  ignore_warning: boolean;
}
